var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _circle, _circle2, _line, _line2, _line3, _circle3, _path2, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForbidden403(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5C77D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#C8A55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9C7E3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "goldSoft6",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E5C77D",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C8A55B",
    stopOpacity: 0.05
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 62,
    width: 84,
    height: 104,
    rx: 8,
    fill: "url(#goldSoft6)",
    stroke: "url(#gold6)",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 72,
    width: 28,
    height: 36,
    rx: 4,
    fill: "none",
    stroke: "url(#gold6)",
    strokeWidth: 1,
    strokeOpacity: 0.35
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 72,
    width: 28,
    height: 36,
    rx: 4,
    fill: "none",
    stroke: "url(#gold6)",
    strokeWidth: 1,
    strokeOpacity: 0.35
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 118,
    width: 64,
    height: 36,
    rx: 4,
    fill: "none",
    stroke: "url(#gold6)",
    strokeWidth: 1,
    strokeOpacity: 0.35
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 80,
    width: 6,
    height: 8,
    rx: 2,
    fill: "url(#gold6)",
    fillOpacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 120,
    width: 6,
    height: 8,
    rx: 2,
    fill: "url(#gold6)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142 62 L152 70 L152 158 L142 166",
    stroke: "url(#gold6)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "url(#goldSoft6)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 110,
    r: 12,
    fill: "none",
    stroke: "url(#gold6)",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 110,
    r: 6,
    fill: "url(#goldSoft6)",
    stroke: "url(#gold6)",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 122,
    x2: 162,
    y2: 150,
    stroke: "url(#gold6)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 132,
    x2: 157,
    y2: 136,
    stroke: "url(#gold6)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: 142,
    x2: 157,
    y2: 146,
    stroke: "url(#gold6)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 110,
    r: 5,
    fill: "url(#goldSoft6)",
    stroke: "url(#gold6)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135 115 L141 115 L139 126 L137 126 Z",
    fill: "url(#goldSoft6)",
    stroke: "url(#gold6)",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 138,
    cy: 115,
    r: 14,
    fill: "url(#gold6)",
    fillOpacity: 0.06
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden403);
export default __webpack_public_path__ + "static/media/forbidden-403.0136116ae823e2bee4ed3a8554bc0494.svg";
export { ForwardRef as ReactComponent };